// setTimeout(() => {

    const palettes = [
        ['chartreuse-1', 'blue-4'],
        ['green-3', 'blue-2'],
        ['fuchsia-3', 'red-3'],
        ['yellow-1', 'green-4'],
        ['brown-1', 'blue-2'],
        ['blue-1', 'purple-4'],
        ['fuchsia-3', 'red-2'],
        ['fuchsia-1', 'black'],
        ['orange-1', 'fuchsia-4'],
        ['purple-3', 'brown-2'],
        ['yellow-3', 'green-4'],
        ['purple-1', 'black'],
        ['blue-3', 'red-2'],
        ['red-1', 'fuchsia-4'],
        ['turquoise-1', 'purple-4'],
        ['chartreuse-1', 'black'],
        ['brown-1', 'purple-2'],
        ['green-1', 'green-4'],
        ['green-2', 'black'],
        ['yellow-1', 'fuchsia-4'],
        ['green-3', 'green-4'],
        ['blue-3', 'purple-2'],
        ['pink-1', 'black'],
        ['purple-2', 'blue-4'],
        ['turquoise-1', 'grey-2'],
        ['orange-1', 'purple-4'],
        ['yellow-3', 'blue-2']
    ];
    

    document.querySelectorAll(".navItem").forEach(navItem => {
        if (!navItem) return;
    
        navItem.addEventListener("mouseenter", function(){
            const palette = palettes[Math.floor(Math.random()*palettes.length)];
            if (Math.random()<0.5){
                navItem.style.backgroundColor=`var(--${palette[0]})`
                navItem.style.color=`var(--${palette[1]})`
            } else {
                navItem.style.backgroundColor=`var(--${palette[1]})`
                navItem.style.color=`var(--${palette[0]})`
            }
        })
        navItem.addEventListener("mouseleave", function(){
            navItem.style.backgroundColor="transparent";
            navItem.style.color="black";

        })
    });